import React, { FC } from 'react';
import { useTranslate } from '@im/react-localization';
import { Form, ButtonSet, ButtonSetProps, FormCtrl } from 'src/components/Form';
import { ProductGroup } from 'src/views/productGroups/hooks/useProductGroups';
import {
  AddProductsToProductGroupRequest,
  useAddProductsToGroup,
} from 'src/views/productGroups/hooks/useProducts';
import AddProductsInput from './AddProductsInput';

export interface AddProductsFormProps {
  onClose: (result?: any) => void;
  productGroup: Pick<ProductGroup, 'id'>;
}

const AddProductsForm: FC<AddProductsFormProps> = ({
  onClose,
  productGroup: { id },
}) => {
  const mutation = useAddProductsToGroup(id);
  const translate = useTranslate();

  const formProps = {
    initialState: { products: [] },
    mutation,
    onClose,
    submitLabel: translate('ProductGroups.AddProducts'),
    title: translate('ProductGroups.AddProducts'),
    validations: {
      products: (value: any) =>
        !value?.length && translate('CustomerGroups.validationRequired'),
    },
  };

  const buttonSetComponent = ({
    formCtrl,
    ...props
  }: ButtonSetProps<AddProductsToProductGroupRequest>): JSX.Element => (
    <ButtonSet formCtrl={formCtrl} {...props} />
  );
  const fieldsComponent = ({
    getInputProps,
  }: FormCtrl<Partial<AddProductsToProductGroupRequest>>): JSX.Element => (
    <AddProductsInput {...getInputProps('products')} />
  );
  return (
    <Form<AddProductsToProductGroupRequest>
      components={{
        buttonSet: buttonSetComponent,
      }}
      fields={fieldsComponent}
      sx={{ width: 860 }}
      {...formProps}
    />
  );
};

export default AddProductsForm;
